import { useConfig } from '@packages/utilities';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { InstallmentCalculatorCallToActionFragmentFragmentDoc } from '@packages/gql/generated/shopping/InstallmentCalculatorCallToActionFragmentFragmentDoc';
import { InstallmentCalulatorInCard } from './InstallmentCalulatorInCard';
import { InstallmentCalulatorInDialog } from './InstallmentCalulatorInDialog';

/* GraphQL */ `
  fragment InstallmentCalculatorCallToActionFragment on InstallmentData {
    numberOfInstallments
    singleInstallment {
      value
      format
    }
    currency
  }
`;

interface InstallmentCalculatorCallToActionProps {
  /**
   * PromotionFragment data fragment
   */
  installmentData: FragmentType<typeof InstallmentCalculatorCallToActionFragmentFragmentDoc>;
  /**
   * Product price value as float (e.g. 13.37)
   */
  basePrice: number;
}

export const InstallmentCalculatorCallToAction = ({
  installmentData,
  basePrice,
}: InstallmentCalculatorCallToActionProps) => {
  const {
    installmentCalculator: { InstallmentCalculatorCallToActionLayout },
  } = useConfig();

  const { numberOfInstallments, singleInstallment, currency } = getFragmentData(
    InstallmentCalculatorCallToActionFragmentFragmentDoc,
    installmentData,
  );

  if (!singleInstallment?.value) {
    return null;
  }

  if (
    InstallmentCalculatorCallToActionLayout.layout === 'Layout3' &&
    InstallmentCalculatorCallToActionLayout.openCalculatorIn.type === 'Card'
  ) {
    return (
      <InstallmentCalulatorInCard
        singleInstallment={singleInstallment.value}
        currency={currency}
        calculatorID={InstallmentCalculatorCallToActionLayout.openCalculatorIn.calculatorID}
      />
    );
  }

  return (
    <InstallmentCalulatorInDialog
      singleInstallment={singleInstallment.value}
      currency={currency}
      numberOfInstallments={numberOfInstallments}
      basePrice={basePrice}
    />
  );
};
